/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Lista_Tarjeta_Caracteristicas_Home from "./SubComponentes/Lista_Tarjeta_Caracteristicas_Home";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Caracteristicas_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container justifyContent={'center'} size={12} sx={{maxWidth: "1400px", px: sCell ? 6 : 3}}>

                <Grid2 container size={{xs: 12, sm: 12, md: 11}} justifyContent={'center'}>

                    <Grid2 container size={12}>

                        <Lista_Tarjeta_Caracteristicas_Home/>

                    </Grid2>


                </Grid2>


            </Grid2>

        </Grid2>
    )

}
export default Caracteristicas_Home